export const MAX_RECORDS_BODY_BYTES = 1024 * 1024;

/**
 * The most values each /api/records list query parameter may carry, in the
 * repeated and comma forms together. A request over a limit is refused with
 * 400 before any handler runs; callers with more ids send them in turns.
 * docIds: delete-documents and getUploadProgress read one silo row per id.
 */
export const RECORDS_LIST_PARAM_LIMITS = {
  docIds: 100,
  componentIds: 200,
  userIds: 200,
} as const;
